export default {
  STYLE: "STYLE",
  LAYERS: "LAYERS",
  DETAILS: "DETAILS",
};
